import { Theme } from '@mui/material';
import { WbGrid, WbGridCol, WbGridRow, WbHeading, WbText } from '@workbench/react';
import { makeStyles } from 'tss-react/mui';
import { FormattedMessage } from 'react-intl';
import { useTranslation } from '../../common/i18n/useTranslation';
import { useMemo } from 'react';
import I18nTexts from '../../common/i18n/I18nTextsCommon';
import { useTranslationContext } from '../../common/i18n/TranslationProvider';
import { SupportedLanguages } from '../../common/i18n/SupportedLanguages';

const useStyles = makeStyles()((theme: Theme) => ({
    gridContainer: {
        width: '100%',
        display: 'grid',
        gap: theme.spacing(3),
    },
}));

export default function LegalNoticeTab() {
    const { classes } = useStyles();
    const translate = useTranslation();
    const { langState } = useTranslationContext();
    const pointIds = useMemo(() => {
        return Array.from(
            { length: langState === SupportedLanguages.de ? 16 : 15 },
            (_, i) => `LegalNoticeTabForwardLookingStatementsPoint${i + 1}`
        );
    }, []);
    return (
        <WbGrid className={classes.gridContainer}>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbHeading size="s">{translate('legal_notices')}</WbHeading>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbHeading size="xs">{translate('LegalNoticeTabIntellectualPropertyTitel')}</WbHeading>
                    <WbText size="l">{translate('LegalNoticeTabIntellectualPropertyContent')}</WbText>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbHeading size="xs">{translate('LegalNoticeTabForwardLookingStatementsTitle')}</WbHeading>
                    <WbText size="l">{translate('LegalNoticeTabForwardLookingStatementsContent')}</WbText>
                </WbGridCol>
            </WbGridRow>
            <WbGridRow>
                <WbGridCol mq1={12}>
                    <WbText size="l">{translate('LegalNoticeTabForwardLookingStatementsSubtitle')}</WbText>
                </WbGridCol>
            </WbGridRow>

            <WbGridRow>
                <WbGridCol mq1={12}>
                    <ul>
                        {pointIds.map((pointId) => {
                            return (
                                <WbText key={pointId} size="l">
                                    <li>{translate(pointId as keyof I18nTexts)}</li>
                                </WbText>
                            );
                        })}
                    </ul>
                </WbGridCol>
            </WbGridRow>

            <WbGridRow>
                <WbGridCol mq1={12}>
                    <FormattedMessage
                        id="LegalNoticeTabForwardLookingStatementsNote"
                        defaultMessage={'LegalNoticeTabForwardLookingStatementsNote'}
                        values={{ br: <br /> }}
                    />
                </WbGridCol>
            </WbGridRow>
        </WbGrid>
    );
}
